import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

const retirementFundsFields: FieldInterface[] = [
  {
    key: 'libelle',
    originKey: 'libelle',
    type: FIELD_TYPES.string,
  },
  {
    key: 'code',
    originKey: 'code',
    type: FIELD_TYPES.string,
  },
]

const retirementFundsRelations: RelationInterface[] = []

export { retirementFundsFields, retirementFundsRelations }
